import { render, staticRenderFns } from "./editGeneralCategories.vue?vue&type=template&id=a2554bfc"
import script from "./editGeneralCategories.vue?vue&type=script&lang=js"
export * from "./editGeneralCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports